$(function() {
  $(document).on('click','#more-faq',() => {
    $('#more-faq').addClass('d-none');
    $('.faq-item-more').addClass('show');
  });
});
